import React from 'react';


import component, {classnames} from './component';


export default component('LoadMoreButton', function({data, text, onClick, loading}) {

  return (
    <div className={classnames('LoadMoreButton', {'LoadMoreButton--Loading': loading})}
         onClick={loading ? null : onClick}>
      {"показать больше " + text}
    </div>
  );

});



// WEBPACK FOOTER //
// ./src/components/LoadMoreButton.js